import { Box } from '@mui/material';
import styled, { css } from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { AccountApprovalModalDesign } from 'utils/types';

export const StyledAccountApproval = styled(Box)<AccountApprovalModalDesign>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ backgroundImage, backgroundColor }) =>
    backgroundImage
      ? `url("${backgroundImage}")`
      : createGradientOrSolid(backgroundColor)};
  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-repeat: no-repeat;
      background-size: cover;
    `}
  width: 343px;
  height: ${({ isAdditionalTextShown }: any) =>
    isAdditionalTextShown ? 'auto' : '343px'};
  border-radius: 15px;
  border: ${({ borderWidth }: any) => borderWidth || 2}px solid
    ${({ borderColor }: any) => borderColor || '#FFFFFF'};
  padding: 40px 43px 16px 43px;

  .approve-button {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    background: ${({ buttonBackgroundColor }: any) =>
      buttonBackgroundColor && createGradientOrSolid(buttonBackgroundColor)};
    color: ${({ buttonTextColor }: any) => buttonTextColor || '#FFFFFF'};
    text-transform: none;
    border-radius: 8px;

    :hover {
      background: ${({ buttonBackgroundColor }: any) =>
        buttonBackgroundColor && createGradientOrSolid(buttonBackgroundColor)};
    }
  }

  .disapprove-button {
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: ${({ buttonTextColor }: any) => buttonTextColor || '#FFFFFF'};
    text-transform: none;
    height: 24px;

    :hover {
      background-color: transparent;
    }
  }

  .additional-text {
    white-space: pre-line;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 12px;
  }

  .footer {
    font-size: 10px;
    color: ${({ textColor }: any) => textColor || '#FFFFFF'};
    margin: 0 10px;
    text-align: center;

    a {
      color: ${({ textColor }: any) => textColor || '#FFFFFF'};
    }
  }

  .account-approval-text {
    color: ${({ textColor }: any) => textColor || '#FFFFFF'};
  }
` as any;

export const StyledPlayerDetails = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    height: 72px;
    width: 72px;
    border-radius: 50px;
    border: 2px solid #ffff;
  }
`;
